import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { translate } from 'react-switch-lang';
import authStorage from '../../storages/mobx/authStorage';
import chatStorage from './chatStorage';
import ChatActionsMenu from './ChatActionsMenu';

class ChatHeader extends Component {
  render() {
    const {
      account: {
        avatar, name, surname, id,
      }, manager: { avatar: managerAvatar, name: managerName, surname: managerSurname },
    } = chatStorage.currentChat;

    const { t } = this.props;
    return (
      <div className="chat-header-container flex-row justify-content-between">
        <div className="flex-row flex-align-items-center">
          <div className="image-container">
            <img src={avatar || '/images/user.png'} alt="" className="img-50 rounded-circle" />
          </div>
          <div className="chat-header_info">
            <div className="contact-info">
              {name}
              {' '}
              {surname}
            </div>
            <div className="contact-info_online">
              {authStorage.onlineStatus === 1 ? 'Online' : 'Offline'}
              {', '}
              {t('Manager')}
              {': '}
              <img src={managerAvatar || '/images/user.png'} className="img-20 rounded-circle" alt={`${managerName} ${managerSurname}`} />
              {managerName}
              {' '}
              {managerSurname}
            </div>
          </div>
        </div>
        <div className="flex-row flex-align-items-center">
          {/* <div className="chat-icons"><i className="fa fa-search" /></div> */}
          {/* <div className="chat-icons"><i className="fa fa-phone" /></div> */}
          <button className="chat-icons button-in-toolbar" onClick={() => chatStorage.loadMessagesForCurrentChat(chatStorage.currentChatID)}><i className="fa fa-refresh" /></button>
          <button className="chat-icons button-in-toolbar" onClick={chatStorage.closeCurrentDialog}><i className="fa fa-eye" /></button>
          <div className="chat-icons"><ChatActionsMenu /></div>
        </div>
      </div>
    );
  }
}

ChatHeader.defaultProps = {
};
ChatHeader.propTypes = {};

export default translate(observer(ChatHeader));
